<template>
  <div v-if="loaded" class="rounded-lg bg-white border border-gray-200 max-w-4xl mx-auto bg-quickstart-purple">
    <div class="p-12 text-center">
      <aside class="text-5xl">👋</aside>
      <h1 class="text-2xl font-bold text-white">Welcome to your Humaniz dashboard!</h1>
      <p class="text-white/80">Congrats on getting started with Humaniz! Let's get you setup for success.</p>
    </div>

    <div class="px-12 pb-12 flex flex-col gap-1">
      <Card v-for="step in incompleteSteps" :key="step.key">
        <div class="flex flex-col lg:flex-row justify-between items-center gap-8">
          <div class="lg:w-4/5">
            <header class="text-lg font-bold text-gray-800">{{ step.title }}</header>
            <p class="text-gray-500 text-sm">{{ step.description }}</p>
          </div>
          <router-link :to="step.link">
            <TButton :disabled="isDisabled(step)">{{ step.buttonText }}</TButton>
          </router-link>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from '../Card/index.vue';

const steps = [
  {
    key: 'users_setup',
    title: 'Invite your teammates',
    description:
      'Running a high performance team is hard. Invite your supporting teammates to help interview candidates, coach your agents, and facilitate a smooth onboarding process.',
    buttonText: 'Invite',
    link: '/settings/company/users?quickstart=true',
  },
  {
    key: 'jobs_setup',
    title: 'Post your first job',
    description:
      'Post your first job to Humaniz so you can start interviewing candidates. We recommend posting at least 7 cities to get the most out of Humaniz.',
    link: '/jobs?sort=created&order=desc&status=Active&quickstart=true',
    buttonText: 'Post a job',
  },
  {
    key: 'teammates_setup',
    title: 'Invite your agent roster',
    description:
      'Invite your agent roster to Humaniz so you can coach your agents with pipeline reviews and enroll them in the Humaniz Online Leads Accelerator.',
    link: '/team?status=Active&sort=created&order=desc&quickstart=true',
    buttonText: 'Invite',
  },
  {
    key: 'phone_number_setup',
    title: 'Setup your Humaniz phone number',
    description: "You'll need a phone number to send and receive text messages to candidates and agents on your team.",
    link: '/quickstart/phone_number',
    buttonText: 'Setup',
  },
  {
    key: 'scheduled_kickoff_call',
    title: 'Schedule a kickoff call',
    description:
      'Have all of the above done? Schedule a kickoff call with our team so you can get the most out of Humaniz!',
    link: '/quickstart/schedule_kickoff_call',
    disabled: true,
    buttonText: 'Schedule',
  },
];

export default {
  components: {
    Card,
  },
  data() {
    return {
      steps: [
        {
          key: 'users_setup',
          title: 'Invite your teammates',
          description: 'Invite your supporting teammates to Humaniz (Recruiters, Sales Managers, Operations, etc.)',
          buttonText: 'Invite',
          link: '/settings/company/users?quickstart=true',
        },
        {
          key: 'jobs_setup',
          title: 'Post your first job',
          description: 'Post your first job with at least 7 cities',
          link: '/jobs?sort=created&order=desc&status=Active&quickstart=true',
          buttonText: 'Post a job',
        },
        {
          key: 'teammates_setup',
          title: 'Invite your agent roster',
          description: 'Invite your agent roster to Humaniz',
          link: '/team?status=Active&sort=created&order=desc&quickstart=true',
          buttonText: 'Invite',
        },
        {
          key: 'phone_number',
          title: 'Setup your Humaniz phone number',
          description: 'Text messages you send to candidates and teammates will come from this number.',
          link: '/quickstart/phone_number',
          buttonText: 'Setup',
        },
        {
          key: 'schedule_kickoff',
          title: 'Schedule a kickoff call',
          description: 'Schedule a kickoff call with our team to get started',
          link: '#',
          disabled: true,
          buttonText: 'Schedule',
        },
      ],
      loaded: false,
      setupProgress: {},
    };
  },
  computed: {
    incompleteSteps() {
      return this.steps.filter(step => !step.completed);
    },
  },
  mounted() {
    this.getTeamSetup();
  },
  methods: {
    async getTeamSetup() {
      const self = this;
      this.steps = steps;
      // self.$store.commit('showLoadingSpinner');
      const res = await fetch(`/api/setup/1`);
      const data = await res.json();
      // self.setupProgress = record.progress;
      for (let setupKey of Object.keys(data.steps)) {
        for (let step of self.steps) {
          if (setupKey == step.key) {
            step.completed = data.steps[setupKey];
            //step.completed = true;
          }
        }
      }
      if (this.incompleteSteps.length === 0) {
        this.$emit('handle-setup-complete');
      }
      self.loaded = true;
    },
    isDisabled(step) {
      if (!step.disabled) {
        return false;
      }

      if (this.incompleteSteps.length === 1) {
        return false;
      }

      return true;
    },
  },
};
</script>
